import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_YEAR_INPUT_TYPE = 'postermywall-year-input';

export const POSTERMYWALL_YEAR_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_YEAR_INPUT_TYPE,
  inputName: 'year',
  dataMarkerAttribute: 'data-is-pmw-form-birthday-input',
  displayName: 'Birthday',
  placeholder: 'YYYY',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-birthday-input') !== null && el.getAttribute('name') === 'year',
  additionalAttributes: {type: 'number', min: 1900},
});
